import { render } from "./messagesVideo.vue?vue&type=template&id=7c13bb65"
import script from "./messagesVideo.vue?vue&type=script&lang=js"
export * from "./messagesVideo.vue?vue&type=script&lang=js"

import "./messagesVideo.vue?vue&type=style&index=0&id=7c13bb65&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__